module.exports = __webpack_public_path__ + "img/MED_LOW_GLYCEMIC@300x.82c92b8f.png";